<template>
  <transition name="ParticlesVoices">
    <div class="ParticlesVoices">
      <canvas ref="canvas"></canvas>
    </div>
  </transition>
</template>

<script>

import Proton from 'proton-js'
import { Visage } from './js/Visage.js'

export default {
  name: 'ParticlesVoices',
  beforeDestroy() {
    this.$renderer.gl.getExtension('WEBGL_lose_context').loseContext()
    this.$proton.destroy()
    window.removeEventListener('resize', this.onResize)
    this.untick()
  },
  activated() {
    this.tick()
  },
  deactivated() {
    this.untick()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.$unlocked = false
    this.$marge = 320
    this.$cue = 0
    const canvas = this.$refs.canvas
          canvas.width = window.innerWidth
          canvas.height = window.innerHeight
    this.$canvas = canvas
    this.$pos = { x: canvas.width / 2, y: canvas.height / 2 }
    this.$cursor = this.$pos
    this.$proton = new Proton()
    this.createProton(canvas)
    this.createRenderer(canvas)
  },
  methods: {
    onResize() {
      TweenMax.set(this.$refs.canvas, { alpha: 0 })

      this.$proton.removeEmitter(this.$emitter)
      this.$proton.destroy(this.$renderer)

      this.$canvas.width = window.innerWidth
      this.$canvas.height = window.innerHeight
      this.$pos = { x: this.$canvas.width / 2, y: this.$canvas.height / 2 }
      this.$cue = 0
      this.$cursor = this.$pos

      if(this.$tween){ this.$tween.kill() }
      this.$tween = TweenMax.delayedCall(0.25, ()=>{
        this.createProton(this.$canvas)
        this.createRenderer(this.$canvas)
        TweenMax.to(this.$refs.canvas, 0.2, { alpha: 1 })
      })
    },

    createProton(canvas) {
      const emitter = new Proton.Emitter()
      this.$attractionBehaviour = new Proton.Attraction(this.$cursor, 20, 1300)
      this.$repulsionBehaviour = new Proton.Repulsion(this.$cursor, 30, 350)
      this.$crossZoneBehaviour = new Proton.CrossZone(new Proton.RectZone(0, 0, canvas.width, canvas.height), 'cross')
      emitter.damping = 0.0075
      emitter.rate = new Proton.Rate(350)
      emitter.addInitialize(new Proton.Body(require('./images/star.gif'), 128, 128))
      emitter.addInitialize(new Proton.Mass(1), new Proton.Radius(Proton.getSpan(5, 10)))
      emitter.addInitialize(new Proton.Velocity(new Proton.Span(1, 3), new Proton.Span(0, 360), 'polar'))
      emitter.addBehaviour(this.customBehaviour(Visage))
      emitter.addBehaviour(this.$attractionBehaviour, this.$repulsionBehaviour, this.$crossZoneBehaviour, new Proton.Color('#5147ac'))
      emitter.addBehaviour(new Proton.Scale(Proton.getSpan(.1, .45)))
      emitter.addBehaviour(new Proton.Rotate(Proton.getSpan(0, 180), Proton.getSpan(-5, 5), 'add'))
      emitter.p.x = canvas.width / 2
      emitter.p.y = canvas.height / 2
      emitter.emit('once')

      this.$proton.addEmitter(emitter)
      this.$emitter = emitter
    },
    createRenderer(canvas) {
      this.$renderer = new Proton.WebGLRenderer(canvas)
      this.$renderer.blendFunc("SRC_ALPHA", "ONE")
      this.$proton.addRenderer(this.$renderer)
    },
    customBehaviour(visage) {
      let index = 0
      return {
        initialize: (particle)=> {
            particle.pos = index
            let x = (index%2 == 0) ? (window.innerWidth/2) - ( 600/2) - _.random(window.innerWidth/4) : (window.innerWidth/2) + ( 600/2) + _.random(window.innerWidth/4)
            let y = _.random(window.innerHeight)
            particle.random = { x: x, y: y }
            index += 1

            particle.R = (index%25 == 0) ? _.random(100, 200) : _.random(5, 50)
            particle.Angle = Math.random() * Math.PI * 2
            particle.speed = Math.random() * (-2) + 1
            particle.zones = visage
        },
        applyBehaviour: (particle)=> {
          if(this.$unlocked) {
            let x, y
            particle.v.clear()
            if(this.$marge === 320) {
              particle.Angle += (particle.pos > this.$marge) ? 0.01 : particle.speed
              x = (particle.pos > this.$marge) ? particle.random.x : particle.zones[particle.pos+this.$cue].x + particle.R * Math.cos(particle.Angle) + (window.innerWidth/2 - 600/2)
              y = (particle.pos > this.$marge) ? particle.random.y + particle.R * Math.sin(particle.Angle) : particle.zones[particle.pos+this.$cue].y + particle.R * Math.sin(particle.Angle) + (window.innerHeight/2 - 768/2)
            }  else  {
              particle.Angle += (particle.pos < this.$marge) ? 0.01 : particle.speed
              x = (particle.pos < this.$marge) ? particle.random.x : particle.zones[particle.pos+this.$cue].x + particle.R * Math.cos(particle.Angle) + (window.innerWidth/2 - 600/2)
              y = (particle.pos < this.$marge) ? particle.random.y + particle.R * Math.sin(particle.Angle) : particle.zones[particle.pos+this.$cue].y + particle.R * Math.sin(particle.Angle) + (window.innerHeight/2 - 768/2)
            }
            particle.p.x += (x - particle.p.x) * 0.035
            particle.p.y += (y - particle.p.y) * 0.035
          }
        }
      }
    },
    tick() {
      this.$rafID = requestAnimationFrame(this.tick)
      this.$proton.update()
    },
    untick() {
      if(this.$rafID)
        cancelAnimationFrame(this.$rafID)
    },

  },

  watch: {
    '$route': {
      immediate: true,
      handler() {
        const slug = this.$route.params.slug
        const timeBeforeFace = 3
        switch(slug) {
          case 'merci':
          case 'introduction':
            this.$nextTick(()=>{
              this.$marge = 320
              this.$cue = 0
              this.$unlocked = false
              this.$cursor = this.$pos
              this.$attractionBehaviour.reset(this.$cursor, 0, 0)
              this.$repulsionBehaviour.reset(this.$cursor, 30, 350)
              TweenMax.delayedCall(timeBeforeFace, ()=>{ this.$unlocked = true })
            })
            break
          case 'introduction:1':
            this.$nextTick(()=>{
              this.$unlocked = false
              this.$cue = 1
              this.$marge = 20
              this.$attractionBehaviour.reset(this.$cursor, 20, 1300)
              this.$repulsionBehaviour.reset(this.$cursor, 0, 0)
              TweenMax.to(this.$cursor, .20, { y: 300, ease: Cubic.easeOut, yoyo:true, repeat: 20 })
              TweenMax.delayedCall(timeBeforeFace, ()=>{ this.$unlocked = true })
            })
            break
          case 'introduction:2':
            this.$nextTick(()=>{
              this.$unlocked = false
              this.$cue = 0
              this.$marge = 320
              this.$repulsionBehaviour.reset(this.$cursor, 200, 350)
              this.$attractionBehaviour.reset(this.$cursor, 2, 6300)
              TweenMax.delayedCall(timeBeforeFace, ()=>{ this.$unlocked = true })
            })
            break
        }
      }
    },
  },

}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ParticlesVoices
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s
  &-enter
  &-leave-active
    opacity 0

  canvas
    position absolute
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// src/components/particles/ParticlesVoice.vue